// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Weiv","colBig":"styles_colBig__3Iid9","colSmall":"styles_colSmall__3B91_","shopifyNameWrapper":"styles_shopifyNameWrapper__DoQ6h"};